module.exports = __webpack_public_path__ + "static/media/customers2.70524297.png";